import { Translate } from '@frontend/translation';
import { HEADER_VARIANTS } from '../PlatformHeader.types';
import {
  RiExchangeFundsLine,
  RiUserLine,
  RiLogoutBoxRLine,
} from '@remixicon/react';
import { Container, MenuItem } from './UserMenu.css';
import IUserMenu from './UserMenu.types';

export default function UserMenu({
  variant,
  switchOperationMode,
  openProfileDrawer,
  openLogoutModal,
}: IUserMenu) {
  const getRoleSwitchTranslationKey = () => {
    return variant === HEADER_VARIANTS.BUYER
      ? 'customer-platform.header.user.menu.menu-item.switch-to-seller-role'
      : 'customer-platform.header.user.menu.menu-item.switch-to-buyer-role';
  };
  return (
    <Container>
      <MenuItem
        icon={<RiExchangeFundsLine size={16} />}
        id="user-header.menu-item.switch-role"
        onClick={switchOperationMode}
      >
        <Translate id={getRoleSwitchTranslationKey()} />
      </MenuItem>
      <MenuItem
        icon={<RiUserLine size={16} />}
        id="user-header.menu-item.profile"
        onClick={openProfileDrawer}
      >
        <Translate id="customer-platform.header.user.menu.menu-item.profile" />
      </MenuItem>
      <MenuItem
        icon={<RiLogoutBoxRLine size={16} />}
        id="user-header.menu-item.logout"
        onClick={openLogoutModal}
      >
        <Translate id="customer-platform.header.user.menu.menu-item.log-out" />
      </MenuItem>
    </Container>
  );
}
